<script>
import GridTable from '../../GridTable.vue'
export default {
  props: {
    componentData: {
      default: {},
    },
  },
  data() {
    return {
      isToggled: false,
    }
  },

  methods: {
    arrowToggle() {
      return (this.isToggled = !this.isToggled)
    },
  },
  components: {
    GridTable,
  },
}
</script>

<template>
  <div style="border: 1px solid #f0f1f1; border-radius: 5px">
    <b-card-header header-tag="header" class="header" role="tab">
      <b-button @click="arrowToggle()" block v-b-toggle="componentData.id" class="w-100 button">
        <div class="inlineButton">
          <div class="buttonTitle">
            {{ componentData.title }}
          </div>
          <div>
            <i :class="{ down: isToggled, up: !isToggled }"> </i>
          </div>
        </div>
      </b-button>
    </b-card-header>
    <b-collapse :id="componentData.id" visible :accordion="componentData.id" role="tabpanel">
      <b-card-body>
        <GridTable :rows="componentData.formData" />
      </b-card-body>
    </b-collapse>
  </div>
</template>

<style lang="scss" scoped>
.header {
  padding: 0;
  background: #f8f9fa;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.0520833);
  border-radius: 5px 5px 0 0;
  width: 100%;
}
.button {
  padding: 11px 20px;
  box-shadow: none;
  border: none;
  background: #f8f9fa;
}
::v-deep .collapsed {
  outline: none;
  border: none;
  background: #fafafa;
}
.buttonTitle {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #444444;
}
.collapse {
  border-top: none;
}
.inlineButton {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
i {
  border: solid #555555;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
}
.down {
  transform: rotate(-135deg);
}
.up {
  transform: rotate(45deg);
}
</style>
